module.exports = __webpack_public_path__ + "img/fif-error.ae31310f.png";